import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { MessageService } from 'src/app/services/toaster/message.service'
import { forkJoin } from 'rxjs';
import { AccessUserInfo, LabRequest, LabRequestDetail, UserDetail, UserLocationFacility } from 'src/app/models';
import { EquipmentService, FacilityService, LabRequestService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DatePipe } from '@angular/common';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import{PreferredLabName} from 'src/app/enum/water-lab/preferredLab'
import { WorkFlow } from 'src/app/enum/water-lab/workFlow';
@Component({
  selector: 'bart-create-lab-request',
  templateUrl: './create-lab-request.component.html',
  styleUrls: ['./create-lab-request.component.scss'],
})
export class CreateLabRequestComponent implements OnInit {
  public userInfo: UserDetail;
  public facilityList: SelectItem[];
  public equipmentList: SelectItem[];
  createLabRequestForm: FormGroup;
  labrotoryData: SelectItem[];
  providerData: SelectItem[];
  labTestdata: SelectItem[];
  labSourceData: SelectItem[];
  labFrequencyData: SelectItem[];
  labProfileData: SelectItem[];
  displayTestName: boolean = true;
  todayDate: Date = new Date();
  enableProviderDDL: boolean = false;
  labRequestDetails: LabRequestDetail
  radioButtons: any[] = [{ name: 'Individual Test', key: 'I' }, { name: 'Profile', key: 'P' }];
  labRequestRowData: LabRequest
  labRequestID: number
  isEditMode: boolean = false;
  defaultSelectedFacility: number;
  disableSaveButton:boolean=false
  selectedFacilityDisplayName:string;
  preferredLabName:string;
  userLocationFacilities: UserLocationFacility[] = [];
  isHomeWorkFlow:boolean=false;
  selectedWorkFlow:string="";
  locationModality:string="";
  //[FREQ-698079]  Lab Action Item No Lab Request  12/14/2023
  selectedEquipmentID:number
  public ENUM_WORKFLOW = WorkFlow;
  constructor
    (
      private _faciliService: FacilityService, private _EquipmentService: EquipmentService,
      private _loaderService: LoaderService, private formBuilder: FormBuilder,
      private _waterLabService: LabRequestService,
      private _messageService: MessageService,
      private _dynamicDialogRef: DynamicDialogRef,
      public dialogConfig: DynamicDialogConfig,
      private datePipe:DatePipe,
      private _userService:UserService,
    ) {
    this._waterLabService.selectedFacility.subscribe(data => {
      this.defaultSelectedFacility = data;
    });
  }

  async ngOnInit() {
    this.preferredLabName=PreferredLabName.name;
    this.userInfo = AccessUserInfo.getUserInfo();
    this.labRequestRowData = this.dialogConfig.data.labRequestRowData
    if (this.labRequestRowData) {
      this.labRequestID = this.labRequestRowData.LabRequestID;
    }
    this.GetUserLocations();
    this.createLabRequestForm = this.formBuilder.group({
      location: [, Validators.required],
      // laboratory: ["", Validators.required],
      equipment: ["", Validators.required],
      labTest: ["", Validators.required],
      labProfile: [""],
      frequency: ["", Validators.required],
      source: [null, Validators.required],
      provider: [null, Validators.required],
      startDate: [new Date(), Validators.required],
      endDate: [""],
      individualTest: [this.radioButtons[0],],
      profile: [],
      requestWorkFlow:[]
    })
    this.setConditionalValidators();
    this.getMasterData();
    //Edit Mode to get the data
    if (this.labRequestID) {
      this.getLabRequestDetails(this.labRequestID, false);
      this.isEditMode = true;
      this.disableSaveButton=true;
      
    }
    // Start Added on 12/14/2023 for [FREQ-698079]  Lab Action Item No Lab Request   facilityMasterID and equipment id reading from LabActionItem page
    if(this.dialogConfig.data.selectedFacilityMasterId){
      this.defaultSelectedFacility=this.dialogConfig.data.selectedFacilityMasterId
    }
    // End  Added on 12/14/2023 for  [FREQ-698079]  Lab Action Item No Lab Request  12/14/2023 facilityMasterID and equipment id reading from LabActionItem page
    if (!this.isEditMode && this.defaultSelectedFacility) {      
      this.createLabRequestForm.get('location').setValue(this.defaultSelectedFacility); 
      this.facilityChanged(this.defaultSelectedFacility);
    }
  }
  setConditionalValidators() {
    this.createLabRequestForm.get('source').valueChanges
      .subscribe(source => {
        if(source!=null){
          if (source.DropDownBoxValue == 'provider') {
            this.createLabRequestForm.get('provider').setValidators([Validators.required]);
          }
          else {
            this.createLabRequestForm.get('provider').setValidators(null)
          }
        }
        this.createLabRequestForm.get('provider').updateValueAndValidity();
      });
    this.createLabRequestForm.get('individualTest').valueChanges
      .subscribe(individualTest => {
        if (individualTest.name == 'Profile') {
          this.createLabRequestForm.get('labProfile').setValidators([Validators.required]);
          this.createLabRequestForm.get('labTest').setValidators(null);
          this.createLabRequestForm.get('labTest').setValue(null);
          this.displayTestName = false
        }
        else {
          this.createLabRequestForm.get('labTest').setValidators([Validators.required]);
          this.createLabRequestForm.get('labProfile').setValidators(null)
          this.createLabRequestForm.get('labProfile').setValue(null)
          this.displayTestName = true
        }
        this.createLabRequestForm.get('labProfile').updateValueAndValidity();
        this.createLabRequestForm.get('labTest').updateValueAndValidity();
      });
  }
  private GetUserLocations() {
    this._loaderService.show();
    this.facilityList = [];
    let getLocationParam =
    {
      "GETUSERLOCATIONS":
      {
        LOCATION_ID_LIST: null,
        USERNAME: this.userInfo.userName,
      },
      "GETUSERLOCATIONS2":
      {
        USERNAME: this.userInfo.userName,
      }
    }
    if (getLocationParam != null) {
      this._faciliService.getUserLocations(JSON.stringify(getLocationParam))
        .subscribe((resp: any) => {
          if( resp.facilities.length>0){
            this.userLocationFacilities=resp.facilities;
            this.facilityList = resp.facilities.filter(x=>x.LocationModality && x.LocationModality.length>0).map(data => ({
            label: data.FacilityDisplayName,
            value: data.FacilityMasterID
          }),
          );
          this._loaderService.hide();                   
        }
        else{
          this._loaderService.hide();
          this.facilityList=[];
        }
        },
          (error) => {
            this._loaderService.hide();
            this.facilityList = [];

          });
    }
  }
  facilityChanged(facilityMasterId: number) {
    this.createLabRequestForm.get('equipment').setValue(null);
    this.createLabRequestForm.get('labTest').setValue(null);
    this.createLabRequestForm.get('labProfile').setValue(null);
    this.createLabRequestForm.get('provider').setValue(null);
    this.createLabRequestForm.get('frequency').setValue(null);
    this.labTestdata=null;
    this.providerData=null;
    this.labFrequencyData=null;
    this.isHomeWorkFlow=this.userLocationFacilities.find(x=>x.FacilityMasterID==facilityMasterId).IsHomeWorkFlow;
    this.locationModality=this.userLocationFacilities.find(x=>x.FacilityMasterID==facilityMasterId).LocationModality;
    this.loadFaclityEquipments(facilityMasterId);
    this.getProviderData(facilityMasterId);
    this.getLabFrequency(facilityMasterId);
    this.selectedWorkFlow= this.ENUM_WORKFLOW.CHRONIC_ACUTE;
    if(this.locationModality=="At Home")
     {
      this.selectedWorkFlow= this.ENUM_WORKFLOW.HOME;
     }
    if(this.isHomeWorkFlow){
      this.selectedWorkFlow=this.ENUM_WORKFLOW.CHRONIC_ACUTE;
      if(this.isEditMode){
        this.selectedWorkFlow=this.labRequestRowData.RequestWorkFlow;
      }
    }    
  }
  loadFaclityEquipments(facilityMasterId: number) {
    this._loaderService.show();
    this.equipmentList = [];
    let GETFACILITYEQUIPMENTSFORLAB =
    {
      "GETFACILITYEQUIPMENTSFORLAB": {
        "FacilityMasterID": facilityMasterId
      }
    }
    this._waterLabService.getFacilityEquipmentsForLab(GETFACILITYEQUIPMENTSFORLAB)
      .subscribe((resp: any) => {
        if(resp.length>0){
        this.equipmentList = resp.map(data => ({
          label: data.EquipmentDisplayName,
          value: data.EquipmentId,
        }));
        this._loaderService.hide();    
        // Start Added on 12/14/2023 for [FREQ-698079]  Lab Action Item No Lab Request   facilityMasterID and equipment id reading from LabActionItem page
        if(this.dialogConfig.data.equipMentID){
          this.selectedEquipmentID=this.dialogConfig.data.equipMentID;
          this.createLabRequestForm.get('equipment').setValue(this.selectedEquipmentID);
          this.equipmentChanged(this.selectedEquipmentID)
        } 
        // End Added on 12/14/2023 for [FREQ-698079]  Lab Action Item No Lab Request   facilityMasterID and equipment id reading from LabActionItem page   
      }
      else{
        this._loaderService.hide();  
        this.equipmentList=[];
      }
      },     
        (error) => {
          this.equipmentList = []
          this._messageService.setErrorPageMessage(error.error);
        }
      );
  }
  selectedTestdata(Jsondata: any) {
    var data = JSON.parse(Jsondata);
    return data.map(data => ({
      label: data.TestDisplayName,
      value: data.LabTestMasterID,
    }));

  }
  selectedProfiledata(Jsondata: any) {
    var data = JSON.parse(Jsondata);
    return data.map(data => ({
      label: data.ProfileDisplayName,
      value: data.LabProfileMasterID,
    }));

  }
  getLabRequestDetails(labRequestID: number, refreshData: boolean,fnCallBack:any=null) {
    this._loaderService.show()
    let getLabRequestDetailsParam = {
      "GETLABREQUESTDETAIL": {
        "LabRequestID": labRequestID
      }
    }
    this._waterLabService.getLabRequestDetails(JSON.stringify(getLabRequestDetailsParam)).subscribe(data => {
      this.labRequestDetails = data.labRequestDetails[0];
      this.labRequestDetails.LabTests = JSON.parse(this.labRequestDetails.LabTestsJson);
      if(this.facilityList && this.labRequestDetails)
      {
        this.selectedFacilityDisplayName=this.facilityList.find(x=>x.value==this.labRequestDetails.FacilityMasterID).label
      }
      if (!refreshData) {
        //these 3 endpoints required only when user click on edit button in dashboard grid, not required on submit button
        this.facilityChanged(this.labRequestDetails.FacilityMasterID);
        this.equipmentChanged(this.labRequestDetails.EquipmentID);
        this.SourceChanged(this.labRequestDetails.LabSourceDDBID);
      }
      this.onRadioButtonChange();
      this.createLabRequestForm.patchValue({
        location: this.labRequestDetails.FacilityMasterID,
        equipment: this.labRequestDetails.EquipmentID,
        labTest: this.labRequestDetails.IsProfile == false && this.labRequestDetails.LabTestsJson != null ? this.selectedTestdata(this.labRequestDetails.LabTestsJson) : null,
        labProfile: this.labRequestDetails.IsProfile == true && this.labRequestDetails.LabProfileJson != null ? this.selectedProfiledata(this.labRequestDetails.LabProfileJson) : null,
        frequency: this.labRequestDetails.LabFrequencyDDBID,
        source: this.labRequestDetails.LabSourceDDBID,
        provider: this.labRequestDetails.NephrologistID,
        startDate: new Date(this.labRequestDetails.StartDate),
        endDate: this.labRequestDetails.EndDate != null ?new Date(this.labRequestDetails.EndDate) : '',
        individualTest: this.labRequestDetails.IsProfile ? this.radioButtons[1] : this.radioButtons[0],
        profile: null,
      })
      //on Submit-- based on  refreshData property will use to update selected row of Lab request data in dashBoard grid data,this method will call only click on submit button in edit mode
        if(refreshData)
        {
        this.labRequestRowData.Frequency=this.labRequestDetails.LabFrequency;
        this.labRequestRowData.Status=this.labRequestDetails.Status;
        this.labRequestRowData.RequestWorkFlow=this.labRequestDetails.RequestWorkFlow;
        if(this.labRequestDetails.LabTests !=null ){
          this.labRequestDetails.LabTests.forEach(item =>{
            item.StartDate= this.datePipe.transform( this.labRequestDetails.StartDate,"MM/dd/yyyy"),
            item.EndDate=this.datePipe.transform(this.labRequestDetails.EndDate,"MM/dd/yyyy");
            item.Source=this.labRequestDetails.LabSource;
          });
        }
        this.labRequestRowData.LabTests = this.labRequestDetails.LabTests;
        if(fnCallBack)
        {
          fnCallBack();// After Call back function will call then hide edit popup to pass updated data to parent page
        }
      }
      this._loaderService.hide();
    },
      err => {
        this._loaderService.hide()
      });

  }
  onSubmit() {
    this.checkValidity()
    if (this.createLabRequestForm.valid) {
    this._loaderService.show();
      let isProfile: any = this.createLabRequestForm.get("individualTest").value["name"] == "Profile" ? true : false;
      let LabRequestDetails = {
        "UPSERTLABREQUEST": {
          UserName: this.userInfo.userName,
          LabRequestID: this.isEditMode ? this.labRequestID : null,
          FacilityMasterID: this.createLabRequestForm.get("location").value,
          EquipmentID: this.createLabRequestForm.get("equipment").value,
          LabFrequencyDDBID: this.createLabRequestForm.get("frequency").value,
          LabSourceDDBID: this.createLabRequestForm.get("source").value,
          NephrologistId: this.createLabRequestForm.get("source").value == 2 ? this.createLabRequestForm.get("provider").value : null,
          NephrologistName: this.createLabRequestForm.get("source").value == 2 ? this.providerData.find(x=>x.value== this.createLabRequestForm.get("provider").value).label : null,
          RequestStartDate:  this.datePipe.transform(this.createLabRequestForm.get("startDate").value, "MM/dd/yyyy"),
          RequestEndDate: this.createLabRequestForm.get("endDate").value == '' ? null : this.datePipe.transform(this.createLabRequestForm.get("endDate").value, "MM/dd/yyyy"),
          IsProfile: isProfile,
          LabTests: !isProfile && this.createLabRequestForm.get("labTest").value != '' ? this.createLabRequestForm.get("labTest").value.map(x => x.value.toString()).toString() : null,
          LabProfiles: isProfile && this.createLabRequestForm.get("labProfile").value != '' ? this.createLabRequestForm.get("labProfile").value.map(x => x.value.toString()).toString() : null,
          RequestWorkFlow:this.selectedWorkFlow
        }
      }

      this._waterLabService.upsertLabRequest(JSON.stringify(LabRequestDetails)).subscribe(data => {
        this._loaderService.hide();
        if (this.isEditMode && data.upsertLabRequest.length>0) {
          this.getLabRequestDetails(data.upsertLabRequest[0].LabRequestID, true,()=>{
            this._dynamicDialogRef.close();
          })
        }
        else
        {
          this._dynamicDialogRef.close();
        }
        //let Description=this.isEditMode?UserActionDescription.EDIT_LABREQUEST_SUBMIT:UserActionDescription.CREATE_LABREQUEST_SUBMIT;
        //#region User Action Audit
        this._userService.logUserAction({
          userName:this.userInfo.userName,
          userAction:UserAction.BUTTON_CLICKED,
          screenName:this.isEditMode?ScreenName.EDIT_LABREQUEST:ScreenName.CREATE_LABREQUEST,
          screenPath:location.pathname,key:'LabRequestID',
          value:this.isEditMode?this.labRequestID.toString():data.upsertLabRequest[0].LabRequestID,
          eventDescription:UserActionDescription.LABREQUEST_POPUP_SAVE_CLICKED
        }); 
        //#endregion
      },
        err => {
          this._loaderService.hide()
        });
    }
    else {
      this._messageService.showAlertMessage("Lab Request:You haven't entered required data")
    }
  }
  public checkValidity(): void {
    Object.keys(this.createLabRequestForm.controls).forEach((key) => {
      this.createLabRequestForm.controls[key].markAsDirty();
    });
  }
  getMasterData() {
    let getLabSourceParam =
    {
      "GETDROPDOWNBOX":
      {
        "DropDownBoxGroup": "LabSource"
      }
    }
   this._waterLabService.getLabDropDownBox(getLabSourceParam).subscribe((response: any) => {
    if(response.length>0){
      this._loaderService.hide();
      this.labSourceData = response.map(data => ({
        label: data.DropDownBoxValue,
        value: data.DropDownBoxId,
      }));
    }
    else{
      this.labSourceData=[];
      this._loaderService.hide();
    }
  }, (error) => {
      this._loaderService.hide();
      this._messageService.setErrorPageMessage('Error Occurred while loading Master Data');
    }
    )
  }
  equipmentChanged(equipmentId: number) {
    this.createLabRequestForm.get('labTest').setValue(null);
    this.createLabRequestForm.get('labProfile').setValue(null);
    if(equipmentId!=null){
      this._loaderService.show()
      let getLabTestsParam = {
        "GETLABTESTS": {
          EquipmentID: equipmentId,
        },
      }
      let getLabProfileParam = {
        "GETLABPROFILES": {
          EquipmentID: equipmentId,
        },
      }
      this._waterLabService.getLabTestData(JSON.stringify(getLabTestsParam)).subscribe(res => {
        if(res.length>0){
          this.labTestdata = res.map(data => ({
            label: data.LabTestDisplayName,
            value: data.LabTestMasterId,
          }));
          this._loaderService.hide()
        }
        else{
          this.labTestdata=null;
          this._loaderService.hide()
        }
      },
        err => {
          this._loaderService.hide()
        });
      this._waterLabService.getLabProfile(JSON.stringify(getLabProfileParam)).subscribe(res => {
        if(res.length>0){
        this.labProfileData = res.map(data => ({
          label: data.ProfileDisplayName,
          value: data.LabProfileMasterId,
        }));
        this._loaderService.hide();
      }
      else{
        this.labProfileData=null;
        this._loaderService.hide()
      }
  
      },
        err => {
          this._loaderService.hide()
        });
    }
    else{
      this.labProfileData=null;
      this.labTestdata=null;
    }

  }
  getProviderData(facilityMasterId) {
    let getProviderparam = {
      "GETPROVIDERS": {
        "FacilityMasterID": facilityMasterId
      },

    }
    this._waterLabService.getProviderData(JSON.stringify(getProviderparam)).subscribe(res => {
      if (res.length > 0) {
        res.sort(function(a, b) { 
          return a.FacilityNo - b.FacilityNo  ||  a.FirstName.localeCompare(b.FirstName);
        });
      this.providerData = res.map(data => ({
        label: data.PhysicianDisplayName,
        value: data.PhysicianId,
      }));
      
      this._loaderService.hide();
    }
    else{
      this.providerData =[];
      this._loaderService.hide();
    }
    },
      err => {
        this._loaderService.hide()
      });
  }
  onRadioButtonChange() {
    this.setConditionalValidators();
  }
  SourceChanged(event: any) {
    if (event == 2) {
      this.enableProviderDDL = true;
    }
    else {
      this.enableProviderDDL = false;
    }
    this.createLabRequestForm.get("provider").setValue(null);
    this.createLabRequestForm.get('provider').setValidators(null)
    this.createLabRequestForm.get('provider').updateValueAndValidity();
  }
  closePopup() {
    //#region User Action Audit
      this._userService.logUserAction({
        userName:this.userInfo.userName,
        userAction:UserAction.BUTTON_CLICKED,
        screenName:this.isEditMode?ScreenName.EDIT_LABREQUEST:ScreenName.CREATE_LABREQUEST,
        screenPath:location.pathname,
        key:'LabRequestID',
        value:this.isEditMode?this.labRequestID !=null || this.labRequestID !=undefined?this.labRequestID.toString():'':'',
        eventDescription:UserActionDescription.LABREQUEST_POPUP_CANCEL_CLICKED
      }); 
    //#endregion

   
    let alertMessae = this.isEditMode  ? "Confirm Cancel of this Lab Request. No changes will be saved." : 'Confirm Cancel of this Lab Request. No data will be saved.'
  
    if(this.isEditMode && !this.disableSaveButton){
      //this._messageService.showAlertMessage("You haven't saved this data, are you sure you want to cancel");
      this._messageService.genericConfirm(
        {
          message: "You haven't saved this data, are you sure you want to cancel",
          header: "Lab Request",
          acceptLabel: "Ok",
        },
        () => {
          this._dynamicDialogRef.destroy();
          //#region User Action Audit
          this._userService.logUserAction({
            userName:this.userInfo.userName,
            userAction:UserAction.BUTTON_CLICKED,
            screenName:this.isEditMode?ScreenName.EDIT_LABREQUEST:ScreenName.CREATE_LABREQUEST,
            screenPath:location.pathname,
            key:'LabRequestID',
            value:this.isEditMode?this.labRequestID !=null || this.labRequestID !=undefined?this.labRequestID.toString():'':'',
            eventDescription:UserActionDescription.LABREQUEST_POPUP_CANCEL_CLICKED
          }); 
          //#endregion
          
        }, () => {
          //#region User Action Audit
          this._userService.logUserAction({
            userName:this.userInfo.userName,
            userAction:UserAction.BUTTON_CLICKED,
            screenName:this.isEditMode?ScreenName.EDIT_LABREQUEST:ScreenName.CREATE_LABREQUEST,
            screenPath:location.pathname,
            key:'LabRequestID',
            value:this.isEditMode?this.labRequestID.toString():'',
            eventDescription:UserActionDescription.LABREQUEST_POPUP_DISCONTINUE_CONFIRM_CANCEL_CLICKED
          }); 
          //#endregion

  
      });
      return true
    }
   
    this._messageService.genericConfirm(
      {
        message: alertMessae,
        header: "Lab Request",
        acceptLabel: "Yes",
        rejectLabel: "Cancel"
      },
      () => {
        this._dynamicDialogRef.destroy();
        
        //let CancelDescription=this.isEditMode?UserActionDescription.EDIT_LABREQUEST_CONFRM_YES:UserActionDescription.CREATE_LABREQUEST_CONFRM_YES;
        //#region User Action Audit
        this._userService.logUserAction({
          userName:this.userInfo.userName,
          userAction:UserAction.BUTTON_CLICKED,
          screenName:this.isEditMode?ScreenName.EDIT_LABREQUEST:ScreenName.CREATE_LABREQUEST,
          screenPath:location.pathname,key:'LabRequestID',
          value:this.isEditMode?this.labRequestID.toString():'',
          eventDescription:UserActionDescription.LABREQUEST_POPUP_CANCEL_CONFIRM_YES_CLICKED

        }); 
        //#endregion
      }, () => {
         //#region User Action Audit
        this._userService.logUserAction({
          userName:this.userInfo.userName,
          userAction:UserAction.BUTTON_CLICKED,
          screenName:this.isEditMode?ScreenName.EDIT_LABREQUEST:ScreenName.CREATE_LABREQUEST,
          screenPath:location.pathname,
          key:'LabRequestID',
          value:this.isEditMode?this.labRequestID.toString():'',
          eventDescription:UserActionDescription.LABREQUEST_POPUP_CANCEL_CONFIRM_CANCEL_CLICKED
        }); 
        //#endregion
    });
   
  }
  onDiscontinue() {
    //#region User Action Audit
    this._userService.logUserAction({
      userName:this.userInfo.userName,
      userAction:UserAction.BUTTON_CLICKED,
      screenName:ScreenName.EDIT_LABREQUEST,
      screenPath:location.pathname,
      key:'LabRequestID',
      value:this.isEditMode?this.labRequestID.toString():'',            
      eventDescription:UserActionDescription.LABREQUEST_POPUP_DISCONTINUE_CLICKED
    }); 
    //#endregion
    let currentContext = this;
    let alertMessae = "Confirm Cancellation of this Lab Request. This cannot be undone."
    this._messageService.genericConfirm(
      {
        message: alertMessae,
        header: "Lab Request",
        acceptLabel: "Yes",
        rejectLabel: "Cancel"
      },
      () => {
        let disContinueLabRequestDetails = {
          "DISCONTINUELABREQUEST": {
            LabRequestID:currentContext.labRequestID,
            UserName:currentContext.userInfo.userName,
            RequestEndDate:this.datePipe.transform(new Date(), "MM/dd/yyyy"),
          }
        }
        currentContext._loaderService.show();
        currentContext._waterLabService.disContinueLabRequest(JSON.stringify(disContinueLabRequestDetails)).subscribe(data => {
          currentContext._loaderService.hide();
          currentContext._dynamicDialogRef.close();
          if (currentContext.isEditMode) {
            currentContext.labRequestRowData.Status = "Inactive";
            currentContext.labRequestRowData.LabTests.forEach(item=>
              {
                item.EndDate=this.datePipe.transform(new Date(), "MM/dd/yyyy")
              });
          }
          //#region User Action Audit
          this._userService.logUserAction({
            userName:this.userInfo.userName,
            userAction:UserAction.BUTTON_CLICKED,
            screenName:ScreenName.EDIT_LABREQUEST,
            screenPath:location.pathname,
            key:'LabRequestID',
            value:this.isEditMode?this.labRequestID.toString():'',            
            eventDescription:UserActionDescription.LABREQUEST_POPUP_DISCONTINUE_CONFIRM_YES_CLICKED
          }); 
          //#endregion
        },
          err => {
            currentContext._loaderService.hide()
          });
      }, () => {
        //#region User Action Audit
        this._userService.logUserAction({
          userName:this.userInfo.userName,
          userAction:UserAction.BUTTON_CLICKED,
          screenName:ScreenName.EDIT_LABREQUEST,
          screenPath:location.pathname,
          key:'LabRequestID',
          value:this.isEditMode?this.labRequestID.toString():'',
          eventDescription:UserActionDescription.LABREQUEST_POPUP_DISCONTINUE_CONFIRM_CANCEL_CLICKED
        }); 
         //#endregion

    });
  }
  onChangeStartDate(){
    let StartDate=new Date(this.createLabRequestForm.get("startDate").value)
    let EndDate=new Date(this.createLabRequestForm.get("endDate").value)
    if(EndDate<StartDate){
      this.createLabRequestForm.get("endDate").setValue(null)
    }
  }
  getLabFrequency(facilityMasterId){
    let getLabFrequencyParam =
    {
      "GETLABFREQUENCY":
      {
        "FacilityMasterID": facilityMasterId
      }
    }
    this._waterLabService.getLabFrequency(JSON.stringify(getLabFrequencyParam)).subscribe(res => {
      if (res.getLabFrequencies.length > 0) {
      this.labFrequencyData = res.getLabFrequencies.map(data => ({
        label: data.DropDownBoxValue,
        value: data.DropDownBoxID,
      }));
      this._loaderService.hide();
    }
    else{
      this.labFrequencyData =[];
      this._loaderService.hide();
    }
    },
      err => {
        this._loaderService.hide()
      });
  }

}
